export interface LocationState {
  country?: { id: string; name: string };
  city?: { id: string; name: string };
  district?: { id: string; name: string };
}

export interface Address {
  name: string;
  email: string;
  mobile: string;
  country: string;
  city: string;
  district: string;
  zipCode: string;
  latitude: string;
  longitude: string;
  address: string;
  nationalAddress: string;
  countryName?: string;
  cityName?: string;
  districtName?: string;
  streetName?: string;
  buildingName?: string;
  buildingNumber?: string;
  iqamaNo?: string;
  dialCode?: string;
}

export interface ShipmentDetails {
  referenceNumber?: string;
  paymentType: string;
  numberOfPieces: string;
  totalWeight: string;
  serviceType?: string;
  shipmentType?: string;
  description?: string;
  shipmentCost?: string;
  codAmount?: string;
}

export interface OrderFormData {
  client?: string;
  clientId?: string;
  clientName?: string;
  sender: Address;
  receiver: Address;
  shipment: ShipmentDetails;
}

export type AddressOption = "short" | "manual" | "map";

export interface ShortAddress {
  shortAddress: string;
  nationalAddress: {
    buildingNumber: string;
    street: string;
    secondaryNumber?: string;
    district: string;
    postalCode: string;
    city: string;
  };
  location?: {
    latitude: number;
    longitude: number;
    googleMapsLink?: string;
  };
  buildingNumber?: string;
  street?: string;
  secondaryNumber?: string;
  district?: string;
  postalCode?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
  googleMapsLink?: string;
}

export interface PickupFormData {
  locationName: string;
  countryId: string;
  cityId: string;
  districtId: string;
  pinCode: string;
  fullAddress: string;
  latitude: string;
  longitude: string;
  shortAddress: string;
}

export interface PickupRequestFormData {
  shipmentsId: string[];
  requestType: string;
  vehicleType: string;
  locationId: string;
  pickupDate: string;
  timeSlot: string;
  warehouseId?: string;
  specialInstructions: string;
}

export interface PickupDropOfRequest {
  shipmentsId: string[];
  pickupDate: string;
  timeSlot: string;
}

// Constants
export const SHIPMENT_SERVICE_OPTIONS = [
  {
    id: "EXPRESS_24_HR",
    value: "Express (24 Hr Delivery)",
    text: "Express (24 Hr Delivery)",
  },
  { id: "SAME_DAY", value: "Same Day Delivery", text: "Same Day Delivery" },
  { id: "NEXT_DAY", value: "Next Day Delivery", text: "Next Day Delivery" },
  { id: "ECONOMY", value: "Economy", text: "Economy" },
  { id: "INTERNATIONAL", value: "International", text: "International" },
];

export const ORDER_SHIPMENT_TYPE_OPTIONS = [
  { id: "PARCEL", value: "PARCEL", text: "PARCEL" },
];

export const PAYMENT_TYPE_OPTIONS = [
  { id: "CC", value: "CC", text: "CC" },
  { id: "COD", value: "COD", text: "COD" },
];
